<template>
  <div class="collection-sub-navigation">
    <nav class="collection-sub-navigation__nav">
      <ul class="collection-sub-navigation__list">
        <li
          v-for="(tier1) of navigation.list"
          :key="tier1.handle"
          class="collection-sub-navigation__item"
        >
          <btn
            v-if="getActive(tier1)"
            :class="[$class('active')]"
            custom-element="div"
            :label="tier1.title"
            :caption="getCaption(tier1)"
            :show-icon="false"
            modifiers="primary"
          />

          <btn
            v-else
            custom-element="a"
            :href="tier1.url"
            :label="tier1.title"
            :caption="getCaption(tier1)"
            :show-icon="false"
            modifiers="theme-color"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>

/**
 * Vue: Collection sub navigation (collection-sub-navigation)
 * -----------------------------------------------------------------------------
 * Collection sub navigation.
 *
 */
import Btn from '~global/btn/btn'

export default {
  name: 'CollectionSubNavigation',

  components: {
    Btn,
  },

  props: {
    navigation: {
      type: Object,
      default: () => ({
        showCounters: true,
        list: [],
      }),
    },
  },

  methods: {

    /**
     * Determine whether to show the product count.
     * @param {Number} count
     * @returns {Boolean}
     */
    showCount(count) {
      if (!count || !this.navigation.showCounters) {
        return false
      }

      return true
    },

    /**
     * Set Button Caption.
     * @param {Object} data
     * @returns {String}
     */
    getCaption(data) {
      if (!data.count || !this.showCount(data.count)) {
        return ''
      }

      return `${data.count}`
    },

    /**
     * Determine if link is active.
     * @param {Object} data
     * @returns {Boolean}
     */
    getActive(data) {
      const handle = data.url.split('/').pop()
      return cnvs.page.handle === handle
    },
  },
}
</script>

<style lang="scss">
@import './collection-sub-navigation';
</style>
